import { prop } from 'datx';
import { inject } from 'dependable-react';
import { computed } from 'mobx';

import { I18N_TOKEN } from '../../services/InjectTokens';
import { BaseModel } from './BaseModel';

export class Field extends BaseModel {
  public static type = 'field';

  @prop
  public uid!: string;

  @prop
  public mandatory!: boolean;

  @prop
  public position!: number;

  @prop
  public maxLength!: number;

  @prop
  public inLanguages!: Array<string>;

  private i18n = inject(I18N_TOKEN);

  @computed
  public get name() {
    return this.i18n.t(this.uid);
  }
}
